export let actions = {
    CREATE: "created",
    UPDATE: "updated",
    DELETE: "deleted",
    ARCHIVE: "archived",
    UNARCHIVE: "unarchived",
    LIKE: "liked a",
    REMOVE_LIKE: "removed like from a",
    MENTION: "mentioned you in a",
};

export let entities = {
    TOPIC: "topic",
    TOPIC_ROLE: "topic role",
    SNIPPET: "snippet",
    COMMENT: "comment",
    TAG: "tag",
};

export let fields = {
    name: "name",
    url: "url",
    publicRole: "public role",
    cluster: "cluster",
    weight: "order",
    description: "description",
};

export let publicRoles = ["restricted", "viewer", "commenter", "editor"];

export function formatField(name, value) {
    switch (name) {
        case "publicRole":
            return publicRoles[value];
        default:
            return value;
    }
}
